import { drawSvg } from "../../assets/image/icon/rough-paper.ts";
class DrawMenu {
  constructor() {
    this.title = '草稿纸'
    this.iconSvg = drawSvg
    this.tag = 'button'
  }
  getValue(editor) {
    return 'listen'
  }
  isActive(editor) {
    return false // or true
  }
  isDisabled(editor) {
    return false // or true
  }
  exec(editor, value) {
    // handleOpen(editor);
    // editor.insertText(value) // value 即 this.getValue(editor) 的返回值
  }
}

const menuConf = {
  key: "roughPaper", // menu key ，唯一。注册之后，需通过 toolbarKeys 配置到工具栏
  factory() {
    return new DrawMenu();
  },
};

export default menuConf;
